import { useEffect, useState } from "react";
import withLoader from "../../../../../components/layouts/WithLoader";
import ProductionOrderService from "../../../../../services/Production/ProductionOrderService";
import { useNavigate } from "react-router-dom";
import getCurrentUserId from "../../../../../reduxSaga/sagas/requests/currentUserId";

import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import DataTableWorkOrdersByPO from "./DataTableWorkOrdersByPO";
import UtilsFormule from "../../../../../utils/UtilsFormule";

const WorkOrderForPOList = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [availableWorkOrders, setAvailableWorkOrders] = useState([]);
  const [productionOrder, setProductionOrder] = useState([]);

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  useEffect(() => {
    startLoading();
    ProductionOrderService.getAllWorkOrdersByPO(
      getCurrentUserId(),
      localStorage.getItem("idPO")
    )
      .then((response) => {
        console.log("response", response);
        if (response.data.success) {
          setAvailableWorkOrders(response.data.success);
          setProductionOrder(response.data.productionOrder);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de bons de travails");
        }
      })
      .catch((e) => {
        console.log("error", e);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <div className="row">
                    {" "}
                    <div className="col-sm-9">
                      <h3 className="card-title">L'ordre de production : </h3>{" "}
                      {productionOrder && productionOrder.code}{" "}
                      {productionOrder && productionOrder.name}
                    </div>
                    <div className="col-sm-3">
                      Date limite :{" "}
                      {productionOrder && UtilsFormule.formatDateHours(productionOrder.scheduledDate)}
                    </div>
                  </div>
                </div>
              </div>
              {availableWorkOrders && (
                <DataTableWorkOrdersByPO listWorkOrder={availableWorkOrders} />
              )}
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(WorkOrderForPOList);
